module.exports = __webpack_public_path__ + "static/media/BIFI-logo.4e504f3e.svg";